export interface UpdateNewsletterPrefsPayload {
  ExplicitConsent: boolean | null;
  NewsletterTypes: number[];
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createUpdateNewsletterPrefsPayload = (getNewsletterPrefsData: any): UpdateNewsletterPrefsPayload => {
  return {
    ExplicitConsent: getNewsletterPrefsData.ExplicitConsent,
    NewsletterTypes: getNewsletterPrefsData.NewsletterType, // this is not a typo: PUT ends with an 's' and GET doesn't
  };
};
